import * as React from "react";
import { StyledStep } from "../../../../components/ReactTourSteps/ReactTourSteps.styles";

export const tourSteps = [
  {
    selector: ".step-1",
    content: () => (
      <StyledStep>
        <h1 className="step-title">Perceptions</h1>
        <p className="step-text">
          I can identify which Perception areas your learners may need support
          in. There are nine Perception areas, click a circle and I'll show you
          an overview of learners in the selected Perception area.
        </p>
        {/* <p className="step-link">
          Find out more about <span>step 1</span> in the
          <span>Help Center</span>{" "}
        </p> */}
      </StyledStep>
    ),
    style: { background: "#2a2a2a" },
  },
];



// WEBPACK FOOTER //
// ./src/pages/DataCenter/School/ViewPerceptions/SchoolPerceptionsTour.tsx